import React from 'react';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '1',
  title: 'Guida ai Supermercati Italiani',
  value: '19€',
  desc: 'Impara a leggere le etichette e a evitare gli interferenti endocrini nascosti nei cibi processati.'
}, {
  num: '2',
  title: 'Checklist "Cucina Detox"',
  value: '17€',
  desc: 'Elimina i 10 nemici della tiroide che hai ora nella tua dispensa senza saperlo.'
}, {
  num: '3',
  title: "Guida all'Aperitivo Sano",
  value: '23€',
  desc: 'Il manuale per goderti la vita sociale in Italia senza bloccare il tuo dimagrimento.'
}];
export function BonusSection() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-8 px-4 bg-brand-soft" data-id="element-27">
      <div className="max-w-2xl mx-auto" data-id="element-28">
        <div className="text-center mb-6" data-id="element-29">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-accent/10 rounded-full mb-4" data-id="element-30">
            <GiftIcon className="w-8 h-8 text-brand-accent" data-id="element-31" />
          </div>
          <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-primary mb-2" data-id="element-32">
            + 3 BONUS ESCLUSIVI
          </h2>
          <p className="text-sm text-brand-text" data-id="element-33">(Valore 59€ INCLUSI GRATIS)</p>
        </div>

        <div className="space-y-4" data-id="element-34">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white border border-brand-border rounded-lg p-5" data-id="element-35">
              <div className="flex items-center gap-2 mb-2" data-id="element-36">
                <span className="bg-brand-accent text-white font-bold px-2 py-1 rounded text-xs uppercase" data-id="element-37">
                  BONUS {bonus.num}
                </span>
                <span className="text-brand-muted text-xs" data-id="element-38">|</span>
                <span className="text-brand-accent font-bold text-xs line-through" data-id="element-39">
                  {bonus.value}
                </span>
                <span className="text-green-600 font-bold text-xs uppercase" data-id="element-40">
                  GRATIS
                </span>
              </div>
              <h3 className="font-bold text-brand-primary text-base mb-1" data-id="element-41">
                {bonus.title}
              </h3>
              <p className="text-sm text-brand-text" data-id="element-42">{bonus.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}